var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-planet"},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":_vm.imgPath}})]),_c('div',{staticClass:"title-wrapper"},[_c('p',{staticClass:"title font-bunkyu-midashi"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }